"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.array.find.js");
require("core-js/modules/es.object.to-string.js");
var _react = _interopRequireDefault(require("react"));
var _inputWysiwyg = require("@citrus/input-wysiwyg");
var _inputSwitch = require("@citrus/input-switch");
var _layout = require("@citrus/layout");
var _PctyQuestionBuilder = require("./PctyQuestionBuilder.Common");
var _questionBuilder = require("@pcty/question-builder");
var _PctyQuestionBuilder2 = require("./PctyQuestionBuilder.Constants");
var _label;
var Presentational = function Presentational(_ref) {
  var id = _ref.id,
    content = _ref.content,
    includeSectionHeading = _ref.includeSectionHeading,
    editable = _ref.editable,
    onQuestionUpdated = _ref.onQuestionUpdated;
  var questionTypeId = _questionBuilder.QUESTION_TYPE.title;
  var _onChange = function onChange(rawContent) {
    var updatedContent = (0, _inputWysiwyg.toHtml)(rawContent);
    if (onQuestionUpdated) onQuestionUpdated({
      questionText: (0, _PctyQuestionBuilder.decodeText)(updatedContent),
      includeSectionHeading: includeSectionHeading
    });
  };
  var onChangeIncludeSectionHeading = function onChangeIncludeSectionHeading(selected) {
    if (onQuestionUpdated) onQuestionUpdated({
      questionText: (0, _PctyQuestionBuilder.decodeText)(content),
      includeSectionHeading: selected
    });
  };
  var questionTypeInfo = _PctyQuestionBuilder2.QUESTION_TYPES_LIST.find(function (x) {
    return x.questionTypeId === questionTypeId;
  });
  var decodedContent = (0, _PctyQuestionBuilder.decodeText)(content);
  return editable ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("label", {
    className: "pcty-input-label question-display-label"
  }, questionTypeInfo.label), /*#__PURE__*/_react.default.createElement("div", {
    className: "pcty-row pcty-padding-top pcty-padding-bottom"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "pcty-col-xs-6"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "pcty-input-wrapper"
  }, _label || (_label = /*#__PURE__*/_react.default.createElement("label", {
    className: "pcty-input-label"
  }, "Include Section Heading")), /*#__PURE__*/_react.default.createElement(_inputSwitch.Switch, {
    id: "".concat(id, "-include-section-heading"),
    toggledOn: includeSectionHeading,
    onChange: function onChange(sel) {
      return onChangeIncludeSectionHeading(sel);
    },
    textOff: "No",
    textOn: "Yes"
  })))), includeSectionHeading && /*#__PURE__*/_react.default.createElement(_inputWysiwyg.Wysiwyg, {
    id: id + '-section-title-wysiwyg',
    key: id + '-section-title-wysiwyg-key',
    onChange: function onChange(rc) {
      return _onChange(rc);
    },
    placeholder: "Please enter your text",
    rawContentState: !!content ? (0, _inputWysiwyg.fromHtml)(decodedContent) : null,
    toolbar: ['bold', 'italic', 'underline', 'unordered-list', 'ordered-list', 'undo', 'redo']
  })) : /*#__PURE__*/_react.default.createElement(_layout.SectionTitle, {
    style: {
      margin: '0',
      flexGrow: '1'
    }
  }, includeSectionHeading ? (0, _PctyQuestionBuilder.removeHtmlTags)(decodedContent) : '');
};
var _default = exports.default = Presentational;